import cards from '../data/rarepepe-sources.mjs';

// Category-specific associations confirmed by the creator. Planning-sheet
// references are not necessarily the references used in the finished artwork.
const associations = {
  mouth: { CLASSIC: 'RAREPEPE', PEPETOWN: 'PEPETOWN', PEPEJOINTSPH: 'PEPEJOINTSPH', PEPEOMUERTE: 'PEPEOMUERTE' },
  naka: Object.fromEntries(['RAREPEPE', 'LORDKEK', 'HOODEDPEPE', 'HAIRPEPE', 'PEPEMINING', 'PEAKYPEPE', 'PEPESMALLS', 'RADIOPEPE'].map(asset => [asset, asset])),
  eyes: { ...Object.fromEntries(['RAREPEPE', 'PEPEKEEPER', 'FSBPUTINPEPE', 'DANKPEPE', 'FROGBUS', 'JIHANWU', 'BLAINEPEPE', 'PEPECASH'].map(asset => [asset, asset])) },
  background: { ...Object.fromEntries(['MODERNPEPE', 'PEPEBASQUIAT', 'PEPENOPOULOS', 'PEPEMINING', 'HAIRPEPE', 'RARELORDKEK', 'MELANCHOLIA', 'PEPLACERESLT', 'DJPEPE', 'HOMERPEPE', 'PEPEPARTY', 'REDPUTINPEPE'].map(asset => [asset, asset])), REDPUTIN: 'REDPUTINPEPE', PEPEMONDRIAN: 'PEPMONDRIAN', PEPMONDRIAN: 'PEPMONDRIAN' },
};

export function traitSource(category, value) {
  const name = String(value || '').trim().toUpperCase();
  const preview = {
    naka: { 'CLUB NFT': ['Club NFT', 'club-nft'], 'PEPE CAP': ['Pepe Cap', 'pepe-cap'] },
    background: { 'TO THE MOON': ['To The Moon', 'to-the-moon'], 'SALVADOR VOLCANO': ['Salvador Volcano', 'salvador-volcano'], 'VOLCANO CURRENCY': ['Salvador Volcano', 'salvador-volcano'] },
  }[category]?.[name];
  if (preview) return {
    kind: 'preview', asset: preview[0], caption: preview[0],
    image: `/img/traits/${preview[1]}.png`,
  };
  const punk = category === 'eyes' && { '3D GLASSES': [8033, '3D Glasses'], SUNGLASSES: [3233, 'Sunglasses'] }[name];
  if (punk) return {
    kind: 'reference', asset: `CryptoPunk #${punk[0]}`,
    href: `https://www.cryptopunks.app/cryptopunks/details/${punk[0]}`,
    image: `https://www.larvalabs.com/public/images/cryptopunks/punk${punk[0]}.png`,
    fallbackImage: `https://www.larvalabs.com/cryptopunks/cryptopunk${punk[0]}.png`,
    caption: `${punk[1]} · CryptoPunk #${punk[0]}`,
    provider: 'CryptoPunks',
  };
  const asset = associations[category]?.[name];
  const card = cards[asset];
  if (!card) return null;
  return {
    ...card,
    href: `https://fairmints.io/collections/counterparty/rarepepes/serie${card.series}/card${card.card}`,
    image: card.image_url,
    fallbackImage: `https://api.bitrare.io/api/v1/counterparty/media/${asset}?kind=full`,
  };
}
